export default {
  catalogue: "каталог".toUpperCase(),
  blog: "блог".toUpperCase(),
  faq: "F.A.Q".toUpperCase(),
  about_fraudvision: "больше о  FraudVision".toUpperCase(),
  contact_us: "КОНТАКТЫ".toUpperCase(),

  thats_the_vision: "thats the vision".toUpperCase(),
};
